module.exports = __webpack_public_path__ + "static/media/41.4a12c626.jpg";